import { render } from "./Header.vue?vue&type=template&id=4425188a&scoped=true"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"

import "./Header.vue?vue&type=style&index=0&id=4425188a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4425188a"

export default script